var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isMounted)?_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.path})],1):_vm._e(),(_vm.isMounted && _vm.authorizedUser)?_c('help'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }